var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_47666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#FEF2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 34L29.7 32.5C29.5 32.4167 29.3125 32.3292 29.1375 32.2375C28.9625 32.1458 28.7833 32.0333 28.6 31.9L27.15 32.35L26.15 30.65L27.3 29.65C27.2667 29.45 27.25 29.2333 27.25 29C27.25 28.7667 27.2667 28.55 27.3 28.35L26.15 27.35L27.15 25.65L28.6 26.1C28.7833 25.9667 28.9625 25.8542 29.1375 25.7625C29.3125 25.6708 29.5 25.5833 29.7 25.5L30 24H32L32.3 25.5C32.5 25.5833 32.6875 25.6708 32.8625 25.7625C33.0375 25.8542 33.2167 25.9667 33.4 26.1L34.85 25.65L35.85 27.35L34.7 28.35C34.7333 28.55 34.75 28.7667 34.75 29C34.75 29.2333 34.7333 29.45 34.7 29.65L35.85 30.65L34.85 32.35L33.4 31.9C33.2167 32.0333 33.0375 32.1458 32.8625 32.2375C32.6875 32.3292 32.5 32.4167 32.3 32.5L32 34H30ZM31 31C31.55 31 32.0208 30.8042 32.4125 30.4125C32.8042 30.0208 33 29.55 33 29C33 28.45 32.8042 27.9792 32.4125 27.5875C32.0208 27.1958 31.55 27 31 27C30.45 27 29.9792 27.1958 29.5875 27.5875C29.1958 27.9792 29 28.45 29 29C29 29.55 29.1958 30.0208 29.5875 30.4125C29.9792 30.8042 30.45 31 31 31ZM17 32C16.45 32 15.9792 31.8042 15.5875 31.4125C15.1958 31.0208 15 30.55 15 30V18C15 17.45 15.1958 16.9792 15.5875 16.5875C15.9792 16.1958 16.45 16 17 16H23L25 18H33C33.55 18 34.0208 18.1958 34.4125 18.5875C34.8042 18.9792 35 19.45 35 20V23.275C34.4167 22.8583 33.7833 22.5417 33.1 22.325C32.4167 22.1083 31.7083 22 30.975 22C29.0083 22 27.3542 22.6875 26.0125 24.0625C24.6708 25.4375 24 27.075 24 28.975C24 29.5083 24.0583 30.025 24.175 30.525C24.2917 31.025 24.4667 31.5167 24.7 32H17Z",
    fill: "#F6B804"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_47666",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_47666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_47666",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeIcon);
export default __webpack_public_path__ + "static/media/practice-icon.7e511ca6a71c8704c87a176dd25d417d.svg";
export { ForwardRef as ReactComponent };